// Stand-in for react-beautiful-dnd, aliased in craco.config.js.
// material-table always mounts DragDropContext, which writes <style> tags that the
// portal's CSP (style-src 'self') blocks. The portal never uses table drag-and-drop
// (column dragging is disabled), so these render their children with inert props.

const noopRef = () => {};

export const DragDropContext = ({ children }) => children;

export const Droppable = ({ children }) =>
  children(
    { innerRef: noopRef, droppableProps: {}, placeholder: null },
    { isDraggingOver: false, draggingOverWith: null, draggingFromThisWith: null, isUsingPlaceholder: false }
  );

export const Draggable = ({ children }) =>
  children(
    { innerRef: noopRef, draggableProps: { style: {} }, dragHandleProps: null },
    { isDragging: false, isDropAnimating: false, draggingOver: null, dropAnimation: null, combineWith: null, combineTargetFor: null, mode: null }
  );

export const resetServerContext = () => {};
